//node_modules
import React from "react";
import { NextPage } from "next";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

//layout
import SiteLayout from "src/layouts/SiteLayout";

//components
import PageHeaderComponent from "src/components/PageHeaderComponent";
import NextLink from "@adjust/website/src/components/NextLink";
import StarRatingComponent from "@adjust/website/src/components/StarRatingComponent";

//locals
import TestimonialComponent from "./components/TestimonialComponent";
import MetaComponent from "./components/MetaDataComponent";

//types
import type { PageProps } from "./types";

const AboutTestimonialsPage: NextPage<PageProps> = ({ testimonials }) => {
  const averageRating = testimonials.length > 0 ? (testimonials.reduce((sum, t) => sum + t.rating, 0) / testimonials.length).toFixed(1) : "5.0";

  return (
    <SiteLayout>
      <MetaComponent />

      <Container className="py-5" style={{ maxWidth: 1200 }}>
        {/* Hero */}

        <Row className="justify-content-center text-center mb-5">
          <PageHeaderComponent type="h1">Client Experiences</PageHeaderComponent>

          <p className="lead text-center mx-auto mb-5">Every vacation tells a story. Read what our clients have to say about working with Adjust to the Good Life Travel.</p>
        </Row>

        {/* Testimonials */}

        <Row className="g-4">
          {testimonials.map((testimonial) => (
            <TestimonialComponent key={testimonial.id} testimonial={testimonial} />
          ))}
        </Row>

        {/* CTA */}

        <Row className="justify-content-center mt-5 pt-3">
          <Col lg={9}>
            <Card className="border-0 bg-light rounded-4 shadow-sm">
              <Card.Body className="text-center p-5">
                <h2 className="fw-bold mb-3">Ready to create your own unforgettable vacation?</h2>

                <p className="lead text-muted mb-4">We'd love to help you plan a journey that's personalized just for you.</p>

                <NextLink href="/contact/">
                  <Button size="lg" className="rounded-pill px-5">
                    Request a Travel Quote
                  </Button>
                </NextLink>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </SiteLayout>
  );
};

export default AboutTestimonialsPage;
